import { render, staticRenderFns } from "./OrtopediUrun.vue?vue&type=template&id=6b39fa49&scoped=true&"
import script from "./OrtopediUrun.vue?vue&type=script&lang=js&"
export * from "./OrtopediUrun.vue?vue&type=script&lang=js&"
import style0 from "./OrtopediUrun.vue?vue&type=style&index=0&id=6b39fa49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b39fa49",
  null
  
)

export default component.exports